import React, { useEffect, useState, useContext, useRef } from "react";
import ListSaveButton from "../../Components/ListSaveButton";
import PageTabs from "../../Components/PageTabs";
import TemplateSettingApi from "../../../API/APIServices/TemplateSetting";
import MyContext from "../../MyContext";
import AlertBox from "../../Props/AlertBox";
import MasterReportDataTable from "../../Master/TableMaster/MasterReportDataTable";
import ReportTableButton from "../../Props/ReportTableButton";
import ItemMaster from "../../Master/InvertoryMaster/ItemMaster";
import AccountMaster1 from "../../Master/AccountMaster/AccountMaster";
import ItemMasterApi from "../../../API/APIServices/ItemMaster";
import { useLocation, useNavigate } from "react-router-dom";
import AccountGroupMaster from "../../Master/AccountMaster/AccountGroupMaster";
import ItemGroupMaster from "../../Master/InvertoryMaster/ItemGroupMaster";
import UnitMaster from "../../Master/InvertoryMaster/UnitMaster";
import PrintModal from "../../ModalBox/PrintModal";
import Transaction from "../../../API/APIServices/Transaction";
import ConvertModal from "../../ModalBox/ConvertModal";
import PayRemainingBill from "../../ModalBox/PayRemainingBill";
import Email from "../../../API/APIServices/Email";
import Status from "../../../API/APIServices/Status";
import BillSeriesWiseTemplateSetting from "../../../API/APIServices/BillSeriesWiseTemplateSetting";
import SaleInvoiceAlert from "../../Props/Dropdown/SaleInvoiceAlert";
import ReportDesignForA4 from "../../../Restaurant/Orders/ReportDesignForA4";
import BillLayoutSetting from "../../../API/APIServices/BillLayoutSetting";
import SmsTemplate from "../../../API/APIServices/SmsTemplate";
import Loader from "../../Props/Loader";
import AddVoucher from "../../../API/APIServices/AddVoucher";
import MessageSendModal from "../../ModalBox/MessageSendModal";
import { debounce } from "lodash";
import BarCodeDesign from "../../Transaction/Sale/BarCodePrint";
import AgentApi from "../../../API/APIServices/Agent";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import Company from "../../../API/APIServices/Company";
import ConvertInvoiceAndSynchDataController from "../../../API/APIServices/ConvertInvoiceAndSynchDataController";
import WorkshopModalLens from "../../WorkshopOrder/WorkshopModalLens";
import TransactionTypeSettingService from "../../../API/APIServices/TransactionTypeSetting";
import TransportModal from "../../ModalBox/TransportModal";
import getCaseInSensitiveFieldValueFromObject from "../../../Utils/GetCaseInsensitiveFieldValueFromObject";
import {
  getTodayDateDMY, getFinancialYearDateDMY, getTodayDateYMD,
  getYesterdayDateYMD, getThisWeekRangeYMD, getLast7DaysRangeYMD,
  getThisMonthRangeYMD, getPreviousMonthRangeYMD, DMYFormateToYMDAndViseVersa
} from "./MasterReportCommonUtils/Dates/Dates";


function MasterListReportFormat2(props) {


  const [statusvalue, setstatusvalue] = useState([]);
  const [columnvalue, setcolumnvalue] = useState({});
  const [selectedOptions2, setSelectedOptions2] = useState([]);
  const {
    OpenAlertBoxDelete,
    alertBoxDelete,
    setAlertBoxDelete,
    messageFunction,
    sendWhatsppShareMsgFromPopup,
    sendEmailFromPopup,
    sendSMSFromPopup,
    input1,
    input2,
    input3,
    input4,
    input5,
    input6,
    input7,
    input8,
    accId,
    UserDetails,
    companyData,
    fetchCompanyData,
    AccountLedDefault,
    setAccountLedDefault
  } = useContext(MyContext);
  const [OpenTransportModal, setOpenTransportModal] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [disableDoubleClick, setDisableDoubleclick] = useState(false);
  const [parentGrp, setparentGrp] = useState(null);
  const navigate = useNavigate();
  const [TransId, setTransId] = useState(null);
  const location = useLocation();
  const row = location.state?.row;
  const [Voucherinfo, setVoucherinfo] = useState(null);
  const [BalanceAmount, setBalanceAmt] = useState("");
  const [PageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(document.readyState !== "complete");
  const [data1, setData1] = useState([]);
  const [templateData, setTemplateData] = useState();
  const [DefaultFilter, setDefaultFilter] = useState({});
  const [columns, setColumns] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [DropdownData, setDropdownData] = useState([]);
  const [currentPageId, setCurrentPageId] = useState("");
  const [totalValue, setTotalValue] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [calculatedTotals, setCalculatedTotals] = useState({});
  const [reportAttachTo, setReportAttachTo] = useState("");
  const [DateFilterCustom, setDateFilterCustom] = useState(null);
  const [searchAnyText, setSearchAnyText] = useState(false);
  const [searchByDate, setSearchByDate] = useState(false);
  const [printButton, setPrintButton] = useState(false);
  const [excelButton, setExcelButton] = useState(false);
  const [searchByColumn, setSearchByColumn] = useState(false);
  const [rowWiseEdit, setRowWiseEdit] = useState(false);
  const [rowWisePrint, setRowWisePrint] = useState(false);
  const [rowWiseWhatsapp, setRowWiseWhatsapp] = useState(false);
  const [rowWiseDelete, setRowWiseDelete] = useState(false);
  const [shareButton, setShareButton] = useState(false);
  const [columnShowTotalValue, setColumnShowTotalValue] = useState(false);
  const [firmNameSelect, setFirmNameSelect] = useState(false);
  const [transactionType, setTransactionType] = useState(false);
  const [billSeries, setBillSeries] = useState(false);
  const [templateSettingDTOId, setTemplateSettingDTOId] = useState(0);
  const [StatusOption, setStatusOption] = useState([]);
  const [agentOption, setAgentOption] = useState([]);
  const [
    rowwiseArrowforNavigationtoAnotherPage,
    setRowwiseArrowforNavigationtoAnotherPage,
  ] = useState(false);
  const [rowiseButtonforOpenNewWindow, setrowiseButtonforOpenNewWindow] =
    useState(false);
  const [rowWiseTransportDetails, setrowWiseTransportModal] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [useDoubleClick, setUseDoubleClick] = useState(false);
  const [reportConfig, setReportConfig] = useState([]);

  const [masterId, setMasterId] = useState(0);
  const [universalSearch, setUniversalSearch] = useState("");

  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");

  const [heading, setHeading] = useState("");
  const [queryData, setQueryData] = useState("");

  const [reportType, setReportType] = useState(null);
  const [navigateTo, setNavigateTo] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [alertBoxConfirm, setAlertBoxConfirm] = useState(false);
  const [selectedStatusId, setSelectedStatusId] = useState(0);
  const [selectedStatusId1, setSelectedStatusId1] = useState(0);
  const [transactonId, setTransactonId] = useState(0);
  const [email, setEmail] = useState("");
  const [billSeriesWiseTemplateSetting, setBillSeriesWiseTemplateSetting] =
    useState({});
  const [vouchseriesId, setVouchseriesId] = useState(0);
  const [dynamicColNameState, setDynamicColNameState] = useState([]);

  const [WorkshopModal, setWorkshopModal] = useState(false);
  const [SelectedItem, setSelectedItem] = useState(false);
  const [commonFilter, setCommonFilter] = useState([]);
  const [dateRangeToShow, setDateRangeToShow] = useState({
    dateFrom: "", dateTo: "", nameOfDateFilterWhichSet: ""
  });

  const WithFrameChange = () => {
    const val = document.getElementById("withFrame").value;
    console.log(val);
    if (val === "Y" || val === "y") {
      document.getElementById("FrameName").style.display = "block";
    } else {
      document.getElementById("FrameName").style.display = "none";
    }
  };

  const closeWorkshopModal = () => {
    setWorkshopModal(false);
  };

  function updateFieldName(fieldName, newSuffix) {
    if (!fieldName) {
      return newSuffix;
    }
    const lastDotIndex = fieldName.lastIndexOf(".");
    if (lastDotIndex > -1) {
      const baseName = fieldName.substring(0, lastDotIndex);
      return `${baseName}.${newSuffix}`;
    } else {
      return newSuffix;
    }
  }

  const OpenTModal = () => {
    setOpenTransportModal(!OpenTransportModal);
  };

  const openWorkshopModal = (item) => {
    setWorkshopModal(true);

    const TransId = getCaseInSensitiveFieldValueFromObject("Id", item);
    setTransId(TransId);
    setSelectedItem(item);
  };

  const OpenAlertBoxConfirm = () => {
    setAlertBoxConfirm(!alertBoxDelete);
  };

  const [nameSearch, setNameSearch] = useState(
    props.nameSearch === undefined ? "" : props.nameSearch
  );

  useEffect(() => {
    let name = props.nameSearch === undefined ? "" : props.nameSearch;
    setNameSearch(name);
  }, []);

  useEffect(() => {
    ;
    const handleReadyStateChange = () => {
      if (document.readyState === "complete") {
        setLoading(false);
      }
    };

    if (document.readyState !== "complete") {
      document.addEventListener("readystatechange", handleReadyStateChange);
    }

    return () => {
      document.removeEventListener("readystatechange", handleReadyStateChange);
    };
  }, []);

  const CloseMessagebox = () => {
    setOpenMessageModal(false);
  };

  const SendSMS = () => {
    if (!mobileNo && mobileNo == "") {
      alert("Please provide an valid Mobile No");
      return;
    }
  };
  const SendWhatsapp = async () => {
    ;
    if (!mobileNo && mobileNo == "") {
      alert("Please provide an valid Mobile No");
      return;
    }
    if (selectedStatusId1) {
      var statusData = await Status.GetStatus();
      if (statusData.length > 0) {
        var statusName = statusData.find(
          (item) => item.id == selectedStatusId1
        );
      }
      let WhatsappNoMsgActive = true;
      if (WhatsappNoMsgActive) {
        var FilterData = {
          smsTypeId: 0,
          smsType: statusName.name,
          transId: 0,
          // Number(id),
          accId: 0,
        };
        var templateData = await SmsTemplate.GetAssignTemplatesByName(
          FilterData.smsType,
          FilterData.transId,
          FilterData.accId,
          FilterData.smsTypeId
        );
        if (templateData.length > 0) {
          var messageSend = messageFunction(
            statusName.name,
            transactonId,
            0,
            mobileNo,
            ""
          );
          if (messageSend) {
            alert("whatsapp message send sucessfully");
            // CloseMessagebox();
          }
        }
      }
    }
  };
  const SendEmail = async () => {
    if (selectedStatusId1) {
      if (!email && email == "") {
        alert("Please provide an valid Email");
        return;
      }

      ;
      var statusData = await Status.GetStatus();
      if (statusData.length > 0) {
        var statusName = statusData.find(
          (item) => item.id == selectedStatusId1
        );
      }
      const smsData = await SmsTemplate.GetAssignTemplatesByName(
        statusName.name,
        transactonId,
        0,
        ""
      );
      let msg = smsData[0]?.templateForFormDetails ?? "";
      if (email) {
        const data = {
          to: email,
          subject: "techcherry",
          body: msg,
        };
        await Email.SendEmail(data);
      }
      return;
    }
  };

  const handleSubmitForall = async (e) => {
    try {
      console.log(`statusvalue`, statusvalue);
      // console.log(selectedData);

      const promises = [];

      for (let i = 0; i < selectedItemIds.length; i++) {
        const masterType = reportAttachTo;
        const Transid = selectedItemIds[i];
        const StatusId = statusvalue.find(
          (fitem) => fitem.id == Transid
        )?.statusid;

        if (masterType && Transid && StatusId) {
          // Push the promise to an array
          promises.push(
            AddVoucher.UpdateVouchStatusByid(masterType, Transid, StatusId)
          );
        }
      }

      // Wait for all promises to resolve in parallel
      const results = await Promise.all(promises);
      if (results.isSuccess) {
        alert(`Status Update Successfully!`);
      }
    } catch (error) {
      console.log(error);
      alert(`Status Update Failed!`);
    }
  };

  useEffect(() => {
    if (reportConfig) {
      console.log("reportConfig", reportConfig);
      for (let index = 0; index < reportConfig.length; index++) {
        const item = reportConfig[index];
        setcolumnvalue((prev) => {
          return {
            ...prev,
            [item.columnName]: "",
          };
        });
      }
    }
  }, [reportConfig]);

  useEffect(() => {
    console.log("row", row);
  }, [row]);

  const [filtercondition, setfiltercondition] = useState([]);
  const GetcolName = (name) => {
    var slicedQuery = queryData
      .toLocaleLowerCase()
      .slice(
        queryData.toLocaleLowerCase().indexOf("select") + "select".length,
        queryData.toLocaleLowerCase().indexOf("from")
      );
    let arr = slicedQuery.split(",").map((item) => item.trim());

    // var searchval =
    //   arr.find((item) => {
    //     let parts = item.split(".");
    //     let columnName = parts.length > 1 ? parts[1].trim() : parts[0].trim();
    //     return columnName.toLowerCase() === name.toLowerCase();
    //   }) || null;

    var searchval =
      arr.find((item) => {
        let parts = item.split(".");
        let columnName = parts.length > 1 ? parts[1].trim() : parts[0].trim();

        // Check if there is an alias (subquery case)
        if (item.includes("as")) {
          const aliasMatch = item.match(/as\s+([^\s]+)/i);
          if (
            aliasMatch &&
            aliasMatch[1].toLowerCase() === name.toLowerCase()
          ) {
            return true;
          }
        }

        return columnName.toLowerCase() === name.toLowerCase();
      }) || null;

    if (!searchval) {
      let wildcardTable = arr.find((item) => item.includes(".*"));
      if (wildcardTable) {
        let tableName = wildcardTable.split(".*")[0].trim();
        searchval = `${tableName}.${name}`;
      } else {
        var searchval =
          arr.find((item) => {
            if (name.toLowerCase() === "id") {
              let parts = item.split(".");
              let columnName =
                parts.length > 1 ? parts[1].trim() : parts[0].trim();
              return columnName.toLowerCase() === "id";
            } else {
              return item.toLowerCase().includes(name.toLowerCase());
            }
          }) || name;
      }
    }

    if (searchval) {
      searchval = searchval.replace(/\s+AS\s+.*/i, "").trim();
    }
    return searchval;
  };

  const openModal3 = async (item, reportAttachTo) => {
    try {
      ;
      // setconvertDataModal({ ItemId: id, ReportAttachTo: Number(reportAttachTo) });
      // setIsConvertModal(true);

      const PartyName = getCaseInSensitiveFieldValueFromObject("PartyName", item);
      const BillAmt = getCaseInSensitiveFieldValueFromObject("BillAmt", item);
      const Id = getCaseInSensitiveFieldValueFromObject("Id", item);
      const VouchSeries = getCaseInSensitiveFieldValueFromObject("VouchSeries", item);
      const VouchNo = getCaseInSensitiveFieldValueFromObject("VouchNo", item);

      setPaymenentRemModal({
        PartyName: PartyName,
        balanceamt: BillAmt,
        accountId: Id,
      });
      setTransId(Id);
      setVoucherinfo(`${VouchSeries}:${VouchNo}`);
      // setparentGrp(item.)
      setIsPaymentRem(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleKeyDown = async (e, filter) => {
    debouncedFunction(e, filter);
  };

  const debouncedFunction = debounce(async (e, filt) => {
    const { name, value } = e.target;
    // if (
    //   ["1", "89", "45", "2", "3", "4"].includes(filt.columnSelectBoxWithSaveBtn)
    // ) {
    //   return;
    // }

    if (
      !value &&
      e.key != "ArrowDown" &&
      e.key != "ArrowUp" &&
      e.key != "Enter"
    ) {
      // setfiltercondition([]);
      // fetchDataTemp();
      return;
    }

    var nm = GetcolName(name);
    console.log("nm", nm);

    const isNumeric = !isNaN(value) && !isNaN(parseFloat(value));

    setfiltercondition([
      {
        fieldName: nm,
        operatorName: isNumeric ? "equal" : "like",
        compareValue: value,
      },
    ]);
  }, 500); // 300 ms delay
  const handleAlphabetSelect = (alphabet) => {
    ;
    const get_name_feild_to_search = getNameFeildToSearch();

    if (get_name_feild_to_search) {
      let searchValName = GetcolName(get_name_feild_to_search);

      setfiltercondition((prev) => {
        const index = prev.findIndex(
          (item) =>
            item.fieldName === searchValName &&
            item.operatorName === "startswith"
        );

        if (index !== -1 && prev[index].compareValue === alphabet) {
          // Same filter exists, so remove it
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        }

        const newItem = {
          fieldName: searchValName,
          operatorName: "startswith",
          compareValue: `${alphabet}`,
        };

        const newItem2 = {
          fieldName: templateData.templateSettingDTO.eF1,
          operatorName: "equal",
          compareValue: reportAttachTo,
        };

        if (index !== -1) {
          // Update existing item
          const updated = [...prev];
          updated[index] = newItem;
          return updated;
        } else {
          // Add new item
          return [...prev, newItem, newItem2];
        }
      });
    }
  };

  const changeDoubleClickFilter = (row, url) => {
    try {
      ;
      console.log(`changefilter`, DefaultFilter);

      setAccountLedDefault(row.original.partyid)
      const keys = Object.keys(DefaultFilter);

      const filter = keys
        .map((item) => {
          if (!DefaultFilter[item].column1 || !DefaultFilter[item].column2) {
            return;
          }
          const findValue = row.cells.find(
            (fitem) => fitem.column.Header == DefaultFilter[item].column1
          );
          const isNumeric =
            !isNaN(findValue?.value) && !isNaN(parseFloat(findValue?.value));
          return {
            // fieldName: GetcolName(DefaultFilter[item]?.column2),
            fieldName: DefaultFilter[item]?.column2,
            operatorName: isNumeric ? "equal" : "like",
            // operatorName:  "like",
            compareValue: findValue?.value,
          };
        })
        .filter((item) => item != undefined);
      localStorage.setItem("filter", JSON.stringify(filter));
      localStorage.setItem("partyid", JSON.stringify(row?.original?.partyid));
      console.log(`filter`, filter);

      window.location.replace(url);
    } catch (error) {
      console.log(error);
    }
  };

  const localdata = async () => {
    ;
    const savedFilter = localStorage.getItem("filter");
    if (savedFilter) {
      console.log(`come from localstorage`, JSON.parse(savedFilter));
      const DoubleclickFilter = JSON.parse(savedFilter);
      for (let index = 0; index < DoubleclickFilter.length; index++) {
        const item = DoubleclickFilter[index];
        const e = {
          key: "Enter",
          target: {
            name: item.fieldName,
            value: item.compareValue,
          },
        };
        const getinputHeader = document.getElementById(item.fieldName);
        if (getinputHeader) {
          getinputHeader.value = item.compareValue;
        }
        if (e.target.value != null) {
          await handleKeyDown(e);
        }
      }
    }
  };

  useEffect(() => {
    ;
    if (queryData && templateData && Object.keys(columnvalue) != 0) {
      localdata().then(() => {
        localStorage.removeItem("filter");
      });
    }
  }, [queryData, templateData, columnvalue]);

  const recall = async () => {
    ;
    setLoading(true);
    try {
      let filterData =
        Array.isArray(filtercondition) && filtercondition.length > 0
          ? filtercondition
          : [
            {
              fieldName: "string",
              operatorName: "string",
              compareValue: "string",
            },
          ];

      console.log(templateData);
      const val = await TemplateSettingApi.getDatasetExecuteQueryFilter_Ledger(
        queryData,
        filterData,
        PageNumber,
        pagecount,
        reportType,
        selectedOptions2,
        commonFilter
      );
      listReport(val.table);
      console.log(val);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // if(!isFirstCall){
    recall();
    // }
  }, [PageNumber]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      recall();
    }, 500);

    return () => {
      clearTimeout(debounceTimeout);
    };
  }, [selectedOptions2]);

  const fetchfilter = async () => {
    setLoading(true);
    try {
      ;
      const response =
        await TemplateSettingApi.getDatasetExecuteQueryFilter_Ledger(
          queryData,
          filtercondition,
          PageNumber,
          pagecount, //pagination value
          templateData?.templateSettingDTO.reportType,
          undefined,
          commonFilter
        );
      console.log(response);
      listReport(response.table);

      let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", response.table[0]) ?? 0;

      setTotalRecords(TotalRecords);
    } catch (error) {
      console.error("Error executing query:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (filtercondition !== "") {
      fetchfilter();
    }
  }, [filtercondition]);

  const handleNameChange = (e) => {
    setNameSearch(e.target.value);
  };

  const handleKeyDownUniversal = async (e, filterdata) => {
    //;
    console.log(e.target.value);
    if (e.key === "Enter") {
      setLoading(true);
      console.log("enter click");
      e.preventDefault();

      const { name, value } = e.target;
      console.log(filterdata);
      if (!value) {
        fetchDataTemp();
        return;
      }

      try {
        const finalResults = [];

        for (let i = 0; i < filterdata.length; i++) {
          const item = filterdata[i];

          if (item.accessor.length === 0) {
            continue;
          }
          const isNumeric = !isNaN(value) && !isNaN(parseFloat(value));
          let filterData = [
            {
              fieldName: GetcolName(item.accessor),
              operatorName: isNumeric ? "equal" : "like",
              compareValue: value,
            },
            {
              fieldName: templateData.templateSettingDTO.eF1,
              operatorName: "equal",
              compareValue: reportAttachTo,
            },
          ];

          try {
            // Await the result of the API call
            const response =
              await TemplateSettingApi.getDatasetExecuteQueryFilter_Ledger(
                queryData,
                filterData,
                PageNumber,
                pagecount,
                templateData.templateSettingDTO.reportType,
                undefined,
                commonFilter
              );

            // Collect the result
            finalResults.push(...response.table);
            console.log(response);

            let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", response.table[0]) ?? 0;

            setTotalRecords(TotalRecords);
          } catch (apiError) {
            // Handle errors specific to the API call
            console.error("Error executing query for item:", apiError);
          }
        }

        // After the loop, log and process the final results
        console.log(finalResults);
        listReport(finalResults);
      } catch (error) {
        // Handle errors that occur outside of the loop
        console.error("Error executing query:", error);
      } finally {
        setLoading(false);
      }
    }
  };


  // Update custom dates
  const handleCustomDateChange = async (e, filterData) => {

    const { id, value, textContent } = e.target;
    if (id === "start-date") {
      setCustomStartDate(value);
      return;
    } else if (id === "end-date") {
      setCustomEndDate(value);
      return;
    }

    // --------------------changes --------------------

    if (!value && !textContent) {
      fetchDataTemp();
      return;
    }

    if (!DateFilterCustom) {
      alert("Please Select Date Type");
      return;
    }

    if (textContent == "Apply") {
      if (!customStartDate) {
        alert("Please select start date!");
        return;
      }

      if (!customEndDate) {
        alert("Please select end date!");
        return;
      }

      const tempFilter = [
        {
          fieldName: updateFieldName(
            templateData?.templateSettingDTO?.eF1,
            DateFilterCustom
          ),
          operatorName: "between",
          compareValue: `${customStartDate},${customEndDate}`,
        },
      ];

      let tempCommonFilter = [...commonFilter];

      tempCommonFilter = tempCommonFilter.filter(item => item.operatorName != "between");

      let tempQueryData = queryData;
      if (reportAttachTo == 63) {

        const newCustomStartDate = DMYFormateToYMDAndViseVersa(customStartDate);
        const newCustomEndDate = DMYFormateToYMDAndViseVersa(customEndDate);

        tempQueryData = tempQueryData
          .replace(/set @Date1 = '[^']*';/, `set @Date1 = '${newCustomStartDate}';`)
          .replace(/set @Date2 = '[^']*';/, `set @Date2 = '${newCustomEndDate}';`);

        setQueryData(tempQueryData);
      } else {
        tempCommonFilter.push(tempFilter[0]);
      }

      setCommonFilter(tempCommonFilter);

      setDateRangeToShow({
        dateFrom: customStartDate, dateTo: customEndDate, nameOfDateFilterWhichSet: "Custom Date"
      });

      setLoading(true);

      if (reportAttachTo != 63) {

        try {
          const response = await TemplateSettingApi.getDatasetExecuteQueryFilter(
            tempQueryData,
            [],
            pagecount,
            PageNumber,
            templateData.templateSettingDTO.eF2,
            templateData.templateSettingDTO.reportType,
            tempCommonFilter
          );
          console.log(response);
          listReport(response.table);

          let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", response.table[0]) ?? 0;

          setTotalRecords(TotalRecords);
        } catch (error) {
          console.error("Error executing query:", error);
        }

      }

      setLoading(false);
      return;
    }

    let tempCommonFilter = [...commonFilter];

    tempCommonFilter = tempCommonFilter.filter(item => item.operatorName != "between");

    let startDate = "", endDate = "";
    if (textContent == "Today") {

      const formattedDate = getTodayDateYMD();

      console.log(formattedDate);

      startDate = formattedDate;
      endDate = formattedDate;

    } else if (textContent == "Yesterday") {

      const formattedYesterday = getYesterdayDateYMD();

      console.log(formattedYesterday);

      startDate = formattedYesterday;
      endDate = formattedYesterday;

    } else if (textContent == "This Week") {

      const { startingDate, endingDate } = getThisWeekRangeYMD();

      startDate = startingDate;
      endDate = endingDate;

    } else if (textContent == "Last 7 Days") {

      const { startingDate, endingDate } = getLast7DaysRangeYMD();

      startDate = startingDate;
      endDate = endingDate;

    } else if (textContent == "This Month") {

      const { startingDate, endingDate } = getThisMonthRangeYMD();

      startDate = startingDate;
      endDate = endingDate;

    } else if (textContent == "Previous Month") {

      const { startingDate, endingDate } = getPreviousMonthRangeYMD();

      startDate = startingDate;
      endDate = endingDate;
    }

    if (textContent) {

      let tempQueryData = queryData;

      if (startDate !== "" && endDate !== "") {

        if (reportAttachTo == 63) {

          const newStartDate = DMYFormateToYMDAndViseVersa(startDate);
          const newEndDate = DMYFormateToYMDAndViseVersa(endDate);

          tempQueryData = tempQueryData
            .replace(/set @Date1 = '[^']*';/, `set @Date1 = '${newStartDate}';`)
            .replace(/set @Date2 = '[^']*';/, `set @Date2 = '${newEndDate}';`);

          setQueryData(tempQueryData);
        } else {
          tempCommonFilter.push({

            fieldName: updateFieldName(
              templateData?.templateSettingDTO?.eF1,
              DateFilterCustom
            ),
            operatorName: "between",
            compareValue: `${startDate},${endDate}`,
          });
        }

        setCommonFilter(tempCommonFilter);

        setDateRangeToShow({
          dateFrom: startDate, dateTo: endDate, nameOfDateFilterWhichSet: textContent
        });
      }



      setLoading(true);

      if (reportAttachTo != 63) {

        try {
          const response = await TemplateSettingApi.getDatasetExecuteQueryFilter(
            tempQueryData,
            [],
            pagecount,
            PageNumber,
            templateData.templateSettingDTO.eF2,
            templateData.templateSettingDTO.reportType,
            tempCommonFilter
          );
          console.log(response);
          listReport(response.table);

          let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", response.table[0]) ?? 0;

          setTotalRecords(TotalRecords);
        } catch (error) {
          console.error("Error executing query:", error);
        }
      }

      setLoading(false);
    }

    console.log(filterData);
  };

  useEffect(() => {
    ;
    if (StatusOption.length > 0 && agentOption.length > 0) {
      fetchDataTemp();
    }
  }, [queryData, agentOption, StatusOption]);


  const fetchAgentMaster = async () => {
    try {
      ;
      const Agent = await AgentApi.GetAgent();
      console.log("Agent", Agent);
      if (Agent?.length != 0) {
        setAgentOption(Agent);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchStatusMaster = async () => {
    try {
      ;
      const status = await Status.GetStatus();
      console.log("Status", status);
      if (status?.length != 0) {
        setStatusOption(status);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAgentMaster();
    fetchStatusMaster();
  }, []);

  function getNameFeildToSearch(col_list = []) {
    let colList =
      dynamicColNameState.length != 0 ? dynamicColNameState : col_list;

    for (let i = 0; i < colList.length; i++) {
      let isContainsName = colList[i].Header.toLowerCase().includes("name");
      if (isContainsName) {
        return colList[i].Header;
      }
    }

    return "";
  }

  const [transActionList, setTransActionList] = useState([]);
  const [pagecount, setpagecount] = useState(1);
  const [dbColumnAndReportColumnNameMap, setDBColumnAndReportColumnNameMap] =
    useState({});

    useEffect(()=>{

      console.log("rowwiseArrowforNavigationtoAnotherPage", rowwiseArrowforNavigationtoAnotherPage);
    },[rowwiseArrowforNavigationtoAnotherPage])

  const fetchDataTemp = async () => {
    try {

      setLoading(true);

      const url = window.location.href;
      const id = props.showNav === false ? props.id : url.split("?")[1];

      const filterData = [
        {
          fieldName: "reportAttachTo",
          operatorName: "Equal",
          compareValue: id,
        },
      ];
      const tempdata = await TemplateSettingApi.getTemplateSettingFilter(
        filterData
      );
      console.log(tempdata);
      const FilterTempdata = tempdata.find(
        (item) => item.templateSettingDTO.reportType == 4
      );
      console.log(FilterTempdata.templateSettingDTO.pagination ?? 50);
      var masterid = FilterTempdata.templateSettingDTO.id;
      console.log(masterid);
      setTemplateSettingDTOId(masterid);
      setpagecount(FilterTempdata.templateSettingDTO.pagination);
      setReportAttachTo(id);
      setLoading(false);

      const response = await TemplateSettingApi.getTemplateSettingById(
        masterid
      );
      // alert(id[1])
      console.log(id);
      console.log(response);

      ;
      setTemplateData(response);


      let query = queryData == "" ? response.templateSettingDTO.queryForSql : queryData;


      if (id == 63) {
        const rowdata = localStorage.getItem("partyid");
        const PartyId = JSON.parse(rowdata)

        let financialYearDateDMY = getFinancialYearDateDMY();
        let todayDateDMY = getTodayDateDMY();


        if (PartyId && queryData == "") {
          // query = query.replace(/{{AccId}}/g, PartyId);
          // query = query.replace(/{{Date1}}/g, getFinancialYearDateDMY());
          // query = query.replace(/{{Date2}}/g, getTodayDateDMY());

          // Replace using regex
          query = query
            .replace(/set @AccId = \d+;/, `set @AccId = ${PartyId};`)
            .replace(/set @Date1 = '[^']*';/, `set @Date1 = '${financialYearDateDMY}';`)
            .replace(/set @Date2 = '[^']*';/, `set @Date2 = '${todayDateDMY}';`);

          const financialYearDateYMD = DMYFormateToYMDAndViseVersa(financialYearDateDMY);
          const todayDateYMD = DMYFormateToYMDAndViseVersa(todayDateDMY);

          setDateRangeToShow({
            dateFrom: financialYearDateYMD, dateTo: todayDateYMD, nameOfDateFilterWhichSet: "Custom Date"
          });

          // localStorage.removeItem("partyid")
        }
      }

      console.log("replace-query", query)

      if (queryData == "") {
        setQueryData(query);
      }

      setSearchAnyText(response.templateSettingDTO.search_AnyText);
      setSearchByDate(response.templateSettingDTO.search_ByDate);
      setPrintButton(response.templateSettingDTO.printButton);
      setExcelButton(response.templateSettingDTO.excelButton);
      setSearchByColumn(response.templateSettingDTO.search_ByColumn);
      setRowWiseEdit(response.templateSettingDTO.rowWise_Edit);
      setRowWisePrint(response.templateSettingDTO.rowWise_Print);
      setRowWiseWhatsapp(response.templateSettingDTO.rowWise_Whatsapp);
      setRowWiseDelete(response.templateSettingDTO.rowWise_Delete);
      setFirmNameSelect(response.templateSettingDTO.firmNameSelect);
      setTransactionType(response.templateSettingDTO.transactionTypeSelect);
      setBillSeries(response.templateSettingDTO.billSeriesNameSelect);
      setRowwiseArrowforNavigationtoAnotherPage(
        response.templateSettingDTO.rowWise_ArrowForOtherPage
      );
      setrowiseButtonforOpenNewWindow(
        response.templateSettingDTO.rowWise_TransporterOrOther
      );
      setrowWiseTransportModal(
        response.templateSettingDTO.transactionTypeSelect
      );
      setUseDoubleClick(response.templateSettingDTO.srch1);

      setIsDropdownVisible(response.templateSettingDTO.srch2);

      setReportType(response.templateSettingDTO.reportType);
      setNavigateTo(response.templateSettingDTO.eF3);

      const tempCommonFilter = [];

      setCommonFilter(tempCommonFilter);


      const firmEnable = response.templateSettingDTO.firmNameSelect
        ? response.templateSettingDTO.firmNameSelect
        : false;

      if (response.templateSettingDTO.eF4) {
        const decode = decodeURIComponent(response.templateSettingDTO.eF4);
        const parse = JSON.parse(decode);
        console.log("JSON PARSE", parse);
        setDefaultFilter(parse);
      }

      const defaultFilterData = [
        { Header: "", accessor: "" },
        { Header: "", accessor: "" },
      ];

      const AgentMaster = response.templateSettingReportConfigList.find(
        (item) =>
          item.columnSelectBoxWithSaveBtn == "45" &&
          item.columnName == "Bookedby"
      );
      const StatusMaster = response.templateSettingReportConfigList.find(
        (item) =>
          item.columnSelectBoxWithSaveBtn == "89" &&
          item.columnName == "StatusName"
      );
      var Status = null;
      var Agent = null;
      if (StatusMaster && StatusOption) {
        try {
          Status = StatusOption;
        } catch (error) {
          console.log(error);
        }
      }

      if (AgentMaster && agentOption) {
        try {
          Agent = agentOption;
        } catch (error) {
          console.log(error);
        }
      }

      const DropdownSalelist = [];

      if (response.templateSettingDTO.srch2) {
        var transActionListData = await Transaction.GetTransactionTypes();
        if (transActionListData) {
          // setTransActionList(transActionListData);
          DropdownSalelist.push({
            Header: (
              <select onChange={(e) => changetablevalue(e)} value={id}>
                {transActionListData.length > 0 ? (
                  <>
                    {transActionListData.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.MasterName}
                      </option>
                    ))}
                  </>
                ) : (
                  "no data"
                )}
              </select>
            ),
            accessor: "dropdown",
          });
        }
        setDropdownData(transActionListData);
        setCurrentPageId(id);
      }

      const defaultColumns = [
        {
          Header: (
            <input
              type="checkbox"
              ref={allSelectedRef}
              onChange={handleAllSelect}
            />
          ),
          accessor: "input",
        },
        { Header: "SNO", accessor: "sno" },
      ];

      const dynamicColumns = Array.isArray(
        response.templateSettingReportConfigList
      )
        ? response.templateSettingReportConfigList
            .filter((column) => column.showOrHide)
            .map((column) => ({
              Header:
                column.columnNameByUser.trim() !== ""
                  ? column.columnNameByUser
                  : column.columnName,
              accessor: column.columnName.toLowerCase(),
              priority: parseInt(column.col1, 10) || 0,
            }))
        : [];

      setDynamicColNameState(dynamicColumns);

      const sortedDynamicColumns = dynamicColumns.sort(
        (a, b) => a.priority - b.priority
      );

      const length = response?.templateSettingReportConfigList
        ? response?.templateSettingReportConfigList.length
        : 0;

      const mapDict = {};

      for (let i = 0; i < length; i++) {
        const key =
          response?.templateSettingReportConfigList[
            i
          ].columnName.toLocaleLowerCase();

        const name = GetcolName(key);

        const nameArray = name ? name.split(".") : [""];

        const value = nameArray.length > 1 ? nameArray[1] : nameArray[0];
        mapDict[key] = value.toLocaleLowerCase();
      }

      setDBColumnAndReportColumnNameMap(mapDict);

      const combinedColumns = [
        ...defaultColumns,
        // ...dynamicColumns,
        ...sortedDynamicColumns,
        { Header: "ACTION", accessor: "action" },
      ];

      setColumns(combinedColumns);
      console.log(combinedColumns);

      //;
      const dynamicFilterData = Array.isArray(
        response.templateSettingReportConfigList
      )
        ? response.templateSettingReportConfigList
            .filter((column) => column.showOrHide)
            .map((filter, index) => {
              let headerContent;
              if (filter.columnName === "StatusName") {
                headerContent =
                  Status && Status.length > 0 ? (
                    <div>
                      <select
                        name={filter.columnName}
                        id={`${filter.columnName}`}
                        // onChange={(e) => handleChange(e, filter)}
                      >
                        <option value="">
                          Select {filter.columnNameByUser}
                        </option>
                        {Status.map((item, idx) => (
                          <option key={idx} value={item?.name}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <input
                      type="text"
                      name={filter.columnName}
                      placeholder={filter.columnNameByUser}
                      id={`${filter.columnName}`}
                      onKeyDown={(e) => handleKeyDown(e, filter)}
                    />
                  );
              } else if (filter.columnName === "Bookedby") {
                headerContent =
                  Agent && Agent.length > 0 ? (
                    <div>
                      <select
                        name={filter.columnName}
                        id={`${filter.columnName}`}
                        // onChange={(e) => handleChange(e, filter)}
                      >
                        <option value="">
                          Select {filter.columnNameByUser}
                        </option>
                        {Agent.map((item, idx) => (
                          <option key={idx} value={item?.name}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <input
                      type="text"
                      name={filter.columnName}
                      placeholder={filter.columnNameByUser}
                      id={`${filter.columnName}`}
                      onKeyDown={(e) => handleKeyDown(e, filter)}
                    />
                  );
              } else {
                headerContent = (
                  <input
                    type="text"
                    name={filter.columnName}
                    placeholder={filter.columnNameByUser}
                    id={`${filter.columnName}`}
                    onKeyDown={(e) => handleKeyDown(e, filter)}
                  />
                );
              }

              return {
                Header: headerContent,
                accessor:
                  filter.columnName.toLowerCase() || `dynamic_filter_${index}`,
                priority: parseInt(filter.col1, 10) || 0,
              };
            })
        : [];

      const sortedDynamicFilterData = dynamicFilterData.sort(
        (a, b) => a.priority - b.priority
      );

      const combinedFilterData = [
        ...defaultFilterData,
        // ...dynamicFilterData,
        ...sortedDynamicFilterData,
      ];

      setFilterData(combinedFilterData);
      console.log(combinedFilterData);

      let filterData1 = [
        // {
        //   fieldName: GetcolName("PartyId"),
        //   operatorName: "like",
        //   compareValue: value,
        // },
        {
          fieldName: GetcolName("PartyName"),
          operatorName: "like",
          compareValue: nameSearch,
        },
      ];



      await fetchData({

        rowWiseEdit1: response.templateSettingDTO.rowWise_Edit,
        rowWiseDelete1: response.templateSettingDTO.rowWise_Delete,
        rowWiseWhatsapp1: response.templateSettingDTO.rowWise_Whatsapp,
        rowWisePrint1: response.templateSettingDTO.rowWise_Print,
        rowWiseArrowForOtherPage: response.templateSettingDTO.rowWise_ArrowForOtherPage,
        queryData: queryData,
        combinedTotalValue: response.templateSettingReportConfigList,
        ef1: response.templateSettingDTO.eF1,
        ef2: response.templateSettingDTO.eF2,
        reportType: response.templateSettingDTO.reportType,
        dynamicColumns: dynamicColumns,
        tempCommonFilter: tempCommonFilter
      });

      setReportConfig(response.templateSettingReportConfigList);

      if (nameSearch) {
        let value = props.accID;
        try {
          const finalResults = [];

          ;
          const get_name_feild_to_search = getNameFeildToSearch(dynamicColumns);

          if (get_name_feild_to_search) {
            let filterData = [
              // {
              //   fieldName: GetcolName("PartyId"),
              //   operatorName: "like",
              //   compareValue: value,
              // },
              {
                fieldName: GetcolName(get_name_feild_to_search),
                operatorName: "like",
                compareValue: nameSearch,
              },
            ];
            // Await the result of the API call
            const response =
              await TemplateSettingApi.getDatasetExecuteQueryFilter_Ledger(
                queryData,
                filterData,
                PageNumber,
                pagecount,
                templateData.templateSettingDTO.reportType,
                undefined,
                tempCommonFilter
              );

            finalResults.push(...response.templateSettingReportConfigList);
            // After the loop, log and process the final results
            console.log(finalResults);
            listReport(finalResults);
          }
        } catch (error) {
          // Handle errors that occur outside of the loop
          console.error("Error executing query:", error);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  const fetchData = async (obj) => {
    //;
    setLoading(true);

    const { rowWiseEdit1, rowWiseDelete1, rowWiseWhatsapp1,
      rowWisePrint1, queryData, combinedTotalValue, ef1,
      ef2, reportType, dynamicColumns = [], tempCommonFilter = commonFilter, rowWiseArrowForOtherPage
    } = obj;

    let filterData = [
      /* {
                       fieldName: "mastertype",
                       operatorName: "equal",
                       compareValue: reportAttachTo
                   },
                   {
                       fieldName: "isdeleted",
                       operatorName: "equal",
                       compareValue: "0"
                   }*/
      {
        fieldName: "string",
        operatorName: "string",
        compareValue: "string",
      },
    ];

    if (nameSearch) {
      const get_name_feild_to_search = getNameFeildToSearch(dynamicColumns);

      if (get_name_feild_to_search) {
        filterData = [
          // {
          //   fieldName: GetcolName("PartyId"),
          //   operatorName: "like",
          //   compareValue: value,
          // },
          {
            fieldName: GetcolName(get_name_feild_to_search),
            operatorName: "like",
            compareValue: nameSearch,
          },
        ];
      }
    }

    console.log("fetchrowWiseArrowForOtherPage", rowWiseArrowForOtherPage)

    try {
      const val = await TemplateSettingApi.getDatasetExecuteQueryFilter_Ledger(
        queryData,
        filterData,
        PageNumber,
        pagecount,
        templateData.templateSettingDTO.reportType,
        undefined,
        tempCommonFilter
      );
      console.log(val);
      //;
      listReport(
        val.table,
        rowWiseEdit1,
        rowWiseDelete1,
        rowWiseWhatsapp1,
        rowWisePrint1,
        combinedTotalValue,
        rowWiseArrowForOtherPage
      );

      let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", val.table[0]) ?? 0;

      setTotalRecords(TotalRecords);
    } catch (error) {
      console.log(error);
    }
  };

  console.log(PageNumber);

  const handleNavigation1 = (transId, transType, ToTransType) => {
    navigate(`/saleinvoice/${ToTransType}`, {
      state: {
        ConversionTransId: transId,
        IsConversion: true,
        transTypeT1: transType,
        ConvertType: 1,
      },
    });
  };

  const handleIconClick = (id, ReportType, ToTransType) => {
    ;
    // alert(id);
    handleNavigation1(id, ReportType, ToTransType);
    const conditions = {
      // 71: () => handleNavigation1(id, ReportType, ToTransType),
      2: () => alert("two"),
      3: () => alert("three"),
    };
    if (conditions[ReportType]) {
      conditions[ReportType]();
    } else {
      console.warn("No function found for this ID");
    }
  };

  const handleNavigation = (id, row) => {
    navigate(`/MasterListReportFormat2?${id}`, { state: { row } });
    // window.open(`/MasterListReportFormat2?${id}`, "_blank");
    window.location.reload();
  };
  const alldataref = useRef([]);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
  const [isConvertModal, setIsConvertModal] = useState(false);
  const [isPaymentRem, setIsPaymentRem] = useState(false);
  const [ConvertDataModal, setconvertDataModal] = useState(false);
  const [PaymenentRemModal, setPaymenentRemModal] = useState(false);

  const [billSettData, setBillSettData] = useState([]);
  const [alertBoxForSalePage, setAlertBoxForSalePage] = useState(false);
  // Function to open the modal
  const openModal2 = (id, reportAttachTo) => {
    setconvertDataModal({ ItemId: id, ReportAttachTo: Number(reportAttachTo) });
    setIsConvertModal(true);
  };

  // Function to close the modal
  const closeModal = () => setIsPrintModalOpen(false);
  const closeModal2 = () => setIsConvertModal(false);
  const closeModal3 = () => setIsPaymentRem(false);
  // const fetchBillSettingData = async () => {
  //   try {
  //     const response =
  //       await BillSeriesWiseTemplateSetting.GetAllBillSeriesWiseTemplateSetting();
  //     if (response.isSuccess) {
  //       console.log("response.Result", response.result);
  //       setBillSettData(response.result);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const handleStockOutSubmit = async (e) => {
    e.preventDefault();
    try {
      const res =
        await ConvertInvoiceAndSynchDataController.SetTransConvertInfoData(
          4,
          companyData.id,
          selectedCompany,
          selectedTransId, //from trans id
          0 //to trans id
        );
      console.log("res", res);
      if (res.result.length === 2 && res.result.every((value) => value === 1)) {
        alert("Request Sent Successfully");
      }
    } catch (error) {
      console.error(error);
    }

    toggleModal();
  };

  const toggleModal = () => setIsStockModalOpen(!isStockModalOpen);
  const [DetailsforTransportModal, setDetailsforTransportModal] = useState(null)
  const [companies, setCompanies] = useState([]);
  const [AllCompanies, setAllCompanies] = useState([]);

  const [isStockModalOpen, setIsStockModalOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedTransId, setSelectedTransId] = useState("");

  const [date, setDate] = useState(
    () => new Date().toISOString().split("T")[0]
  );
  const fetchCompanyData1 = async (TransId) => {
    setSelectedTransId(TransId);
    const data = await Company.GetCompany();
    if (data && companyData) {
      const filterComp = data.filter((x) => x.id !== companyData.id);
      console.log("data", filterComp);
      setCompanies(filterComp);
    } else {
      var cdata = await fetchCompanyData();
      const filterComp = data.filter((x) => x.id !== cdata.id);
      console.log("data", filterComp);
      setCompanies(filterComp);
    }
  };

  const fetchCompanyList = async () => {
    const data = await Company.GetCompany();
    if (data) {
      setAllCompanies(data);
    }
  };

  useEffect(() => {
    fetchCompanyList();
  }, []);

  console.log("AllCompanies", AllCompanies);

  const changetablevalue = (e) => {
    const value = e.target.value;

    navigate(`/MasterListReportFormat2?${value}`);
    window.location.replace(`/MasterListReportFormat2?${value}`);
  };

  const handleTransportDetailsModal = (item) => {
    OpenTModal();
    setDetailsforTransportModal(item)
  };

  const listReport = async (
    tableData,
    rowWiseEdit1,
    rowWiseDelete1,
    rowWiseWhatsapp1,
    rowWisePrint1,
    combinedTotalValue,
    rowWiseArrowForOtherPage
  ) => {
    ;
    try {
      let filteredData = tableData;

      let tempCheckedItems = [];
      let tempCheckedItemsRef = [];

      for (let i = 0; i < filteredData.length; i++) {
        let obj = {
          id: filteredData[i].id,
          checked: false,
        };

        // tempCheckedItems.push(obj);
        // tempCheckedItemsRef.push(useRef(null));
      }

      alldataref.current = filteredData.map(() => React.createRef());
      console.log("filteredData", filteredData);

      // setAllCheckedRef(tempCheckedItemsRef);
      // setCheckedItems(tempCheckedItems);

      const newData = filteredData.map((item, i) => {
        ;
        console.log(item);
        const dynamicProperties = Object.entries(item).reduce(
          (acc, [key, value]) => {
            acc[key.toLowerCase()] = value;
            return acc;
          },
          {}
        );

        const Trans1IdT1 = getCaseInSensitiveFieldValueFromObject("Trans1IdT1", item);
        const TransTypeT1 = getCaseInSensitiveFieldValueFromObject("TransTypeT1", item);
        const DBIdT1 = getCaseInSensitiveFieldValueFromObject("DBIdT1", item);
        const Id = getCaseInSensitiveFieldValueFromObject("Id", item);
        const StatusName = getCaseInSensitiveFieldValueFromObject("StatusName", item);
        const StatusId = getCaseInSensitiveFieldValueFromObject("StatusId", item);
        const TotalBalanceQty = getCaseInSensitiveFieldValueFromObject("TotalBalanceQty", item);
        const TransId = getCaseInSensitiveFieldValueFromObject("Id", item);

        return {
          input: (
            <input
              type="checkbox"
              ref={alldataref.current[i]}
              value={Id}
              onMouseLeave={handleMouseLeaveEnable}
              onMouseEnter={handleMouseEnterDisable}
              onChange={(e) => handleCheckboxChange(e, item)}
            />
          ),
          sno: (
            <div
              style={{ cursor: "pointer" }}
              onDoubleClick={() => openWorkshopModal(item)}
            >
              {i + 1}
            </div>
          ),
          ...dynamicProperties,
          action: (
            <div
              className="tablelist-action-box"
              style={{ position: "sticky", right: "0" }}
            >
              {(rowWiseEdit1 || rowWiseEdit) &&

                (parseInt(reportAttachTo) == 53 && StatusId != 934 ? (
                  <i
                    className="fa-solid fa-pen-to-square TableEditIcon"
                    onClick={() => {
                      ;
                      if (UserDetails && UserDetails.canModifyMaster) {

                        navigate(`/saleinvoice/${53}`, {
                          state: {
                            ConversionTransId: Trans1IdT1,
                            IsConversion: true,
                            transTypeT1: TransTypeT1,
                            ConvertType: 3,
                            DBIdT1: DBIdT1, // From Db1Id
                            TableId: Id,
                          },
                        });
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "You have not permission to edit Master!",
                          text: "",
                          timer: 2000,
                          showConfirmButton: false,
                          timerProgressBar: true,
                          width: "250px",
                          customClass: {
                            title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                            popup: "swal2-custom-popup",
                            htmlContainer: "swal2-custom-text",
                            icon: "swal2-custom-icon",
                          },
                        });
                      }
                    }}
                  ></i>
                ) : (
                  <i
                    className="fa-regular fa-pen-to-square TableEditIcon"
                    onClick={() => {
                      if (UserDetails && UserDetails?.canModifyMaster) {
                        editTemplateSetting(item);
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "You have not permission to edit Master!",
                          text: "",
                          timer: 2000,
                          showConfirmButton: false,
                          timerProgressBar: true,
                          width: "250px",
                          customClass: {
                            title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                            popup: "swal2-custom-popup",
                            htmlContainer: "swal2-custom-text",
                            icon: "swal2-custom-icon",
                          },
                        });
                      }
                    }}
                  ></i>
                ))}
              {(rowWiseDelete1 || rowWiseDelete) && (
                <i
                  className="fa-regular fa-trash-can TableDelIcon"
                  onClick={() => {
                    if (UserDetails && UserDetails.canDelVoucher) {
                      deleteTemplateSetting(item);
                    } else {
                      Swal.fire({
                        icon: "warning",
                        title: "You have not permission to delete!",
                        text: "",
                        timer: 2000,
                        showConfirmButton: false,
                        timerProgressBar: true,
                        width: "250px",
                        customClass: {
                          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                          popup: "swal2-custom-popup",
                          htmlContainer: "swal2-custom-text",
                          icon: "swal2-custom-icon",
                        },
                      });
                    }
                  }}
                ></i>
              )}
              {(rowWiseWhatsapp1 || rowWiseWhatsapp) && (
                <i
                  className="fa-brands fa-square-whatsapp TableWhatsappcon"
                  onClick={() => handleShare(Id)}
                ></i>
              )}
              {(rowWisePrint1 || rowWisePrint) && (
                <i
                  className="fa-solid fa-print TablePrint"
                  onClick={() => openModal(item)}
                ></i>
              )}
              {(rowWiseArrowForOtherPage || rowwiseArrowforNavigationtoAnotherPage) && ((StatusName !== "Conv. to Sale" &&
                StatusName !== "Conv. to Sale Challan") ||
                TotalBalanceQty !== 0 ) && (
                <>
                  {
                    <i
                      className="fa-solid fa-arrows-turn-right TableConvertIcon"
                      onClick={() => openModal2(Id, reportAttachTo)}
                    ></i>
                  }
                </>
              )}

              {rowWiseTransportDetails && (
                <>
                  <i
                    onClick={()=>handleTransportDetailsModal(item,reportAttachTo)}
                    style={{ marginLeft: "6px" }}
                    className="fa-solid fa-truck TableStockIcon"
                  ></i>
                </>
              )}

              {Number(reportAttachTo) === 55 && (
                <i
                  className="fa-solid fa-warehouse TableStockIcon"
                  onClick={() => {
                    fetchCompanyData1(TransId);
                    toggleModal();
                  }}
                ></i>
              )}

              {/* </>
              )} */}
              {rowiseButtonforOpenNewWindow && (
                <i
                  class="fa-solid fa-sack-dollar TableConvertIcon"
                  onClick={() => openModal3(item, reportAttachTo)}
                ></i>
              )}
              {false && (
                <i
                  className="fa-solid fa-link TablePrint"
                  onClick={() => alert("popup")}
                ></i>
              )}
            </div>
          ),
        };
      });

      console.log(newData);
      setData1(newData);
      console.log(combinedTotalValue);

      const dynamicTotalValue = Array.isArray(
        combinedTotalValue || reportConfig
      )
        ? (combinedTotalValue || reportConfig).map((total) => {
            const columnName = total.columnName.toLowerCase() || "";
            const columnSum = newData.reduce((sum, row) => {
              const value = parseFloat(row[columnName]);
              return !isNaN(value) ? sum + value : sum;
            }, 0);
            return {
              accessor: total.columnName.toLowerCase(),
              columnShowTotalValue: total.columnShowTotalValue,
              total: columnSum,
              priority: parseInt(total.col1, 10) || 0,
            };
          })
        : [];

      const sortedDynamicTotalValue = dynamicTotalValue.sort(
        (a, b) => a.priority - b.priority
      );

      setTotalValue(sortedDynamicTotalValue);
      console.log("Calculated Totals", sortedDynamicTotalValue);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [editData, setEditData] = useState(null);

  const editTemplateSetting = async (data) => {
    console.log(data);

    const Trans1IdT2 = getCaseInSensitiveFieldValueFromObject("Trans1IdT2", data);
    const Id = getCaseInSensitiveFieldValueFromObject("Id", data);

    try {
      ;
      const url = window.location.href;
      const reportAttachTo =
        props.showNav === false ? props.id : url.split("?")[1];
      var transactionId;
      if (reportAttachTo == 53) {
        // transactionId = data.Trans1IdT2 || data.trans1IdT2;
        transactionId = Trans1IdT2;
      } else {
        transactionId = Id;
      }
      let data1;
      if (transactionId) {
        const data = await Transaction.GetTransactionById(
          transactionId,
          reportAttachTo
        );
        console.log(data);
        setEditData(data);
        navigate(
          `${templateData.templateSettingDTO.pageLink}/${reportAttachTo}`,
          {
            state: { refID: data, isEdit: true, transId: transactionId },
          }
        );
      }
      if (data1) {
        navigate(data1); // Redirect to the appropriate page
        console.log("Navigating to:", data1);
      }
      setMasterId(data);
      toggleSlider();
      setSliderOpen(true); // Open the slider
    } catch (error) {
      console.error("Error editing data:", error);
    }
  };

  const [getMasterType, setGetMasterType] = useState(null);
  const [getdeleteId, setDeleteId] = useState(null);
  const [isSliderOpen, setSliderOpen] = useState(false);

  const toggleSlider = () => {
    console.log(editData);
    setSliderOpen(!isSliderOpen);
  };

  const deleteTemplateSetting = (item) => {
    ;

    const itemId = getCaseInSensitiveFieldValueFromObject("Id", item);

    const url = window.location.href;
    const reportAttachTo =
      props.showNav === false ? props.id : url.split("?")[1];
    setAlertBoxDelete(true);
    setGetMasterType(reportAttachTo);
    setDeleteId(itemId);
  };
  const DeleteTransactionConfirm = async () => {
    setLoading(true);
    ;
    try {
      var val;
      if (reportAttachTo == 53) {
        val =
          await ConvertInvoiceAndSynchDataController.DeleteTransConvertInfoData(
            getdeleteId
          );
      } else {
        val = await Transaction.DeleteTransactionData(getdeleteId);
      }

      if (Boolean(val) === true) {
        await recall();
        setAlertBoxDelete(false);
        setDeleteId(null);
        setLoading(false);
      } else {
        alert("Error Deleting Data");
      }
      await recall();
    } catch (error) {
      console.error("Error deleting account:", error);
    }
  };
  const DeleteTemplateConfirm = async () => {
    setLoading(true);
    //;
    try {
      const val = await TemplateSettingApi.deleteTemplateSetting(
        getMasterType,
        getdeleteId
      );
      console.log(val);

      if (Boolean(val) === true) {
        //;
        setAlertBoxDelete(false);
        setGetMasterType(null);
        setDeleteId(null);
        setLoading(false);
        fetchDataTemp();
      } else {
        alert("Error Deleting Data");
      }
      // fetchData();
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };

  const [selectedData, setSelectedData] = useState([]);
  const [selectedItemIds, setSelectedItemIds] = useState([]);

  const handleMouseEnterDisable = () => {
    setDisableDoubleclick(true);
  };

  const handleMouseLeaveEnable = () => {
    setDisableDoubleclick(false);
  };

  useEffect(() => {
    console.log(`selectedItemIds`, selectedItemIds);
  }, [selectedItemIds]);

  const [checkedItems, setCheckedItems] = useState([]);
  const allSelectedRef = useRef(null);

  const handleAllSelect = (e) => {
    ;
    const boolVal = e.target.checked;
    console.log(boolVal);

    allSelectedRef.current.checked = boolVal;

    for (let i = 0; i < alldataref.current.length; i++) {
      alldataref.current[i].current.checked = boolVal;
    }
  };

  const handleCheckboxChange = (e, propitem) => {
    ;

    const PropItemId = getCaseInSensitiveFieldValueFromObject("Id", propitem);


    let boolVal = e.target.checked;
    console.log(boolVal);

    if (boolVal == false) {
      allSelectedRef.current.checked = false;
    }

    let tempCheckedItems = [...checkedItems];

    for (let i = 0; i < tempCheckedItems.length; i++) {
      if (tempCheckedItems[i] == PropItemId) {
        tempCheckedItems[i].checked = boolVal;
        break;
      }
    }

    setCheckedItems(tempCheckedItems);

    // props.handleSetSelectedId(propitem.id);
    setDisableDoubleclick(false);

    if (!e.target.checked) {
      const tempdata = selectedItemIds?.filter(
        (item) => item !== PropItemId
      );
      setSelectedItemIds(tempdata);
    } else {
      setSelectedItemIds((prev) => [...prev, PropItemId]);
    }

    const selectedItem = data1.find((item) => item.id === PropItemId);
    if (selectedItem) {
      setSelectedData((prevSelectedData) => {
        const isSelected = prevSelectedData.some(
          (item) => item.id === PropItemId
        );

        if (isSelected) {
          return prevSelectedData.filter((item) => item.id !== PropItemId);
        } else {
          return [...prevSelectedData, selectedItem];
        }
      });
    }
    console.log(selectedData);
  };

  const handleShare = (id) => {
    const listToSend = data1.find((item) => {

      const itemId = getCaseInSensitiveFieldValueFromObject("Id", item);
      return itemId === id;
    });
    const whatsappURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      listToSend
    )}`;
    window.location.href = whatsappURL;
  };

  const [createData, setCreateData] = useState(null);
  console.log(createData);

  useEffect(() => {
    createTemplateSetting();
  }, [templateData]);

const createTemplateSetting = async () => {
  ;
  try {
    if (templateData) {
      const pageLink = templateData.templateSettingDTO.pageLink;
      if (pageLink && pageLink !== "/") {
        const CreateUrl = `${pageLink}/${reportAttachTo}`;
        setCreateData(CreateUrl);
      } else {
        setCreateData("");
      }
    }
  } catch (error) {
    console.error("Error creating template setting:", error);
  }
};


  const fetchData1 = async () => {
    try {
      const url = window.location.href;
      const reportAttachTo =
        props.showNav === false ? props.id : url.split("?")[1];
      const response = await TemplateSettingApi.getAllMasterType();
      if (response && Array.isArray(response)) {
        const matchingItem = response.find((item) => item.id == reportAttachTo);

        if (matchingItem) {
          setHeading(matchingItem.name);
        } else {
          console.error(
            "No matching master type found for reportAttachTo:",
            reportAttachTo
          );
        }
      } else {
        console.error("Error:", response.errorMessages);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchData1();
  }, []);
  const Reload = () => {
    window.location.reload();
  };

  const [templateName, setTemplateName] = useState("");
  const [transId, setTransId1] = useState(0);
  const [showBillPrint, setShowBillPrint] = useState(false);
  const [mobileNo, setMobileNo] = useState("");

  useEffect(() => {
    console.log("mobileNo", mobileNo);
    console.log("selectedStatusId1", selectedStatusId1);
    console.log("transactonId", transactonId);
  }, [mobileNo]);

  const PrintBill = () => {
    setShowBillPrint(true);
    setAlertBoxForSalePage(false);
  };

  async function handleFetchWebTemplateSetting(voucherSerriesId) {
    const filter = {
      filter: [
        {
          fieldName: "voucherSeries",
          operatorName: "equal",
          compareValue: voucherSerriesId,
        },
      ],
      order: [
        {
          propertyName: "string",
          ascending: true,
        },
      ],
      pageNumber: 0,
      pageSize: 0,
    };

    try {
      const response =
        await BillSeriesWiseTemplateSetting.GetAllBillSeriesWiseTemplateSettingByFilter(
          filter
        );
      if (response.isSuccess) {
        console.log("BillSeriesWiseTemplateSetting", response.result);
        return response.result[0];
      }

      return {};
    } catch (error) {
      console.log("Error on fethicg BillSeriesWiseTemplateSetting");
      return {};
    }
  }

  // Function to open the modal
  const openModal = async (item) => {
    ;

    const Id = getCaseInSensitiveFieldValueFromObject("Id", item);
    const VoucherSeriesId = getCaseInSensitiveFieldValueFromObject("VoucherSeriesId", item);
    const BillStatusId = getCaseInSensitiveFieldValueFromObject("BillStatusId", item);
    const MobileNo = getCaseInSensitiveFieldValueFromObject("MobileNo", item);
    const Email = getCaseInSensitiveFieldValueFromObject("Email", item);

    setVouchseriesId(VoucherSeriesId);
    setTransId1(Id);
    setSelectedStatusId(BillStatusId);
    setMobileNo(MobileNo);
    setEmail(Email);
    const data = await handleFetchWebTemplateSetting(VoucherSeriesId);
    if (data && data?.showPrintOptionPopup) {
      setBillSeriesWiseTemplateSetting(data);
      setIsPrintModalOpen(true);
    } else {
      setAlertBoxForSalePage(true);
    }
    console.log(item);
  };

  const sendMessage = async (transactonId) => {
    ;
    if (selectedStatusId) {
      var statusData = await Status.GetStatus();
      if (statusData.length > 0) {
        var statusName = statusData.find((item) => item.id == selectedStatusId);
      }

      let WhatsappNoMsgActive = true;
      if (WhatsappNoMsgActive) {
        var FilterData = {
          smsTypeId: 0,
          smsType: statusName.name,
          transId: 0,
          // Number(id),
          accId: 0,
        };
        var templateData = await SmsTemplate.GetAssignTemplatesByName(
          FilterData.smsType,
          FilterData.transId,
          FilterData.accId,
          FilterData.smsTypeId
        );
        if (templateData.length > 0) {
          messageFunction(statusName.name, transId, 0, mobileNo, "");
        }
      }
    }
  };

  const [showBillPrintBarCode, setShowBillPrintBarCode] = useState(false);

  const OpenBillPrintBarCode = () => {
    setShowBillPrintBarCode(true);
  };

  const closeBillPrintBarCode = () => {
    setShowBillPrintBarCode(false);
  };

  const PrintBill2 = async (template_name = "", button_type) => {
    // Email
    if (button_type == 7) {
      await sendEmailFromPopup(transId, email, selectedStatusId);
    }
    //Whatsapp share
    if (button_type == 8) {
      ;
      var statusData = await Status.GetStatus();
      if (statusData.length > 0) {
        var statusName = statusData.find((item) => item.id == selectedStatusId);
      }

      await sendWhatsppShareMsgFromPopup(
        statusName?.name,
        transId,
        0,
        mobileNo,
        "",
        () => console.log("sendWhatsppMsg call")
      );
    }
    // Whatsapp msg
    if (button_type == 10) {
      if (selectedStatusId) {
        var statusData = await Status.GetStatus();
        if (statusData.length > 0) {
          var statusName = statusData.find(
            (item) => item.id == selectedStatusId
          );
        }

        // if (WhatsappNoMsgActive) {
        var FilterData = {
          smsTypeId: 0,
          smsType: statusName.name,
          transId: 0,
          // Number(id),
          accId: 0,
        };
        var templateData = await SmsTemplate.GetAssignTemplatesByName(
          FilterData.smsType,
          FilterData.transId,
          FilterData.accId,
          FilterData.smsTypeId
        );
        if (templateData.length > 0) {
          messageFunction(statusName.name, transId, 0, mobileNo, "");
          // }
        }
      }
    }

    if (button_type == 9) {
      OpenBillPrintBarCode();
    }

    if (!template_name) return;
    console.log(template_name, transId);
    setTemplateName(template_name);
    setShowBillPrint(true);
  };

  function addOrders() {
    let tempSElectedIDs = [];

    for (let i = 0; i < alldataref.current.length; i++) {
      if (alldataref.current[i].current.checked) {
        tempSElectedIDs.push(alldataref.current[i].current.value);
      }
    }

    props.addOrders(tempSElectedIDs);
  }

  const convertDataToAOA = async () => {
    if (selectedData.length !== 0) {
      if (!selectedData.length) {
        return [];
      }
      const fields = Object.keys(props.selectedData[0]);
      const filteredFields = fields.slice(2, -1);

      const sortedData = props.selectedData.sort((a, b) => a["sno"] - b["sno"]);
      const result = [
        filteredFields,
        ...sortedData.map((row) => filteredFields.map((field) => row[field])),
      ];
      return result;
    } else {
      try {
        setLoading(true);
        ;

        var filter;
        if (filtercondition.length == 0) {
          filter = [
            {
              fieldName: "string",
              operatorName: "string",
              compareValue: "string",
            },
          ];
        } else {
          filter = filtercondition;
        }
        const ALL_RECORDS = 999999;
        const response =
          await TemplateSettingApi.getDatasetExecuteQueryFilter_Ledger(
            queryData,
            filter,
            PageNumber,
            ALL_RECORDS,
            templateData.templateSettingDTO.reportType,
            undefined,
            commonFilter
          );
        console.log(response);
        const newData = response.table.map((item, i) => {
          return Object.entries(item).reduce((acc, [key, value]) => {
            acc[key.toLowerCase()] = value;
            return acc;
          }, {});
        });

        const fields = Object.keys(newData[0]);
        // const filteredFields = fields.slice(2, -1);

        return [
          fields,
          ...newData.map((row) => fields.map((field) => row[field])),
        ];
      } catch (error) {
        console.error("Error executing query:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDataExport = async () => {
    ;
    const Data = await convertDataToAOA();
    const ws = XLSX.utils.aoa_to_sheet(Data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    const filename = `table_data_${Date.now()}.xlsx`;
    XLSX.writeFile(wb, filename);
  };

  useEffect(() => {
    console.log("isSliderOpen", isSliderOpen);
  }, [isSliderOpen]);

  const [convertTypeList, setConvertTypeList] = useState([]);

  async function fetchConvertTypeList(transType) {

    try {

      const filter = [
        {
          fieldName: "transType",
          operatorName: "equal",
          compareValue: transType,
        }
      ];

      var data = await TransactionTypeSettingService.getTransactionTypeSettingFilter(
          filter
        );

        if(data){
          const convert_type_list = data[0].convertList;
          if(convert_type_list){
            setConvertTypeList(convert_type_list);
          }
        }

    } catch (error) {
      console.log("Error in fetching transaction type setting", error);
    }
  }
  useEffect(() => {
    if(reportAttachTo){
      fetchConvertTypeList(reportAttachTo);
    }
  }, [reportAttachTo])

  function handleResetQueryDate() {

    let financialYearDateDMY = getFinancialYearDateDMY();
    let todayDateDMY = getTodayDateDMY();

    const tempQueryData = queryData
      .replace(/set @Date1 = '[^']*';/, `set @Date1 = '${financialYearDateDMY}';`)
      .replace(/set @Date2 = '[^']*';/, `set @Date2 = '${todayDateDMY}';`);

    setQueryData(tempQueryData);

    const financialYearDateYMD = DMYFormateToYMDAndViseVersa(financialYearDateDMY);
    const todayDateYMD = DMYFormateToYMDAndViseVersa(todayDateDMY);
    setDateRangeToShow({
      dateFrom: financialYearDateYMD, dateTo: todayDateYMD, nameOfDateFilterWhichSet: "Custom Date"
    });

  }

  return (
    <div className="">
      <PageTabs
        locationTab={createData}
        modelOpen={true}
        setSliderCallBack={setSliderOpen}
      />
      <div className="nav-1">
        <div className="panel-heading">
          <h2 className="panel-title">{heading} List</h2>

          {props.showNav !== false && (
            <ReportTableButton
              createTemplateSetting={createTemplateSetting}
              createData={createData}
              filterData={filterData}
              columns={columns}
              handleDataExport={handleDataExport}
              data={data1}
              selectedData={selectedData}
              printButton={printButton}
              excelButton={excelButton}
              shareButton={shareButton}
              heading={heading}
              customStartDate={dateRangeToShow.dateFrom}
              customEndDate={dateRangeToShow.dateTo}
            />
          )}
        </div>
        <MasterReportDataTable
          debouncedFunction={debouncedFunction}
          PageNumber={PageNumber}
          setPageNumber={setPageNumber}
          pagecount={pagecount}
          fetchData={fetchData}
          filterData={filterData}
          DropdownData={DropdownData}
          changetablevalue={changetablevalue}
          currentPageId={currentPageId}
          columns={columns}
          totalValue={totalValue}
          data={data1}
          searchAnyText={searchAnyText}
          searchByDate={searchByDate}
          searchByColumn={searchByColumn}
          columnShowTotalValue={columnShowTotalValue}
          calculatedTotals={calculatedTotals}
          tableData={tableData}
          universalSearch={universalSearch}
          handleKeyDownUniversal={handleKeyDownUniversal}
          setUniversalSearch={setUniversalSearch}
          customStartDate={customStartDate}
          customEndDate={customEndDate}
          handleCustomDateChange={handleCustomDateChange}
          fetchDataTemp={fetchDataTemp}
          firmNameSelect={firmNameSelect}
          transactionType={transactionType}
          billSeries={billSeries}
          useDoubleClick={useDoubleClick}
          reportAttachTo={reportAttachTo}
          reportType={reportType}
          navigateTo={navigateTo}
          handleNavigation={handleNavigation}
          totalRecords={totalRecords}
          addOrders={addOrders}
          showNav={props.showNav}
          handleNavigation1={handleNavigation1}
          changeDoubleClickFilter={changeDoubleClickFilter}
          setDateFilterCustom={setDateFilterCustom}
          DateFilterCustom={DateFilterCustom}
          templateData={templateData}
          disableDoubleClick={disableDoubleClick}
          setDisableDoubleclick={setDisableDoubleclick}
          statusvalue={statusvalue}
          setstatusvalue={setstatusvalue}
          handleSubmitForall={handleSubmitForall}
          handleMouseLeaveEnable={handleMouseLeaveEnable}
          handleMouseEnterDisable={handleMouseEnterDisable}
          setOpenMessageModal={setOpenMessageModal}
          setSelectedStatusId1={setSelectedStatusId1}
          setTransactonId={setTransactonId}
          setEmail={setEmail}
          setMobileNo={setMobileNo}
          showSetting={true}
          templateSettingDTOId={templateSettingDTOId}
          handleAlphabetSelect={handleAlphabetSelect}
          dbColumnAndReportColumnNameMap={dbColumnAndReportColumnNameMap}
          filtercondition={filtercondition}
          setSelectedOptions2={setSelectedOptions2}
          selectedOptions2={selectedOptions2}
          handleNameChange={handleNameChange}
          rowWiseEdit1={templateData?.templateSettingDTO?.rowWise_Edit}
          rowWiseDelete1={templateData?.templateSettingDTO?.rowWise_Delete}
          rowWiseWhatsapp1={templateData?.templateSettingDTO?.rowWise_Whatsapp}
          rowWisePrint1={templateData?.templateSettingDTO?.rowWise_Print}
          queryData={queryData}
          combinedTotalValue={templateData?.templateSettingReportConfigList}
          ef1={templateData?.templateSettingDTO?.eF1}
          ef2={templateData?.templateSettingDTO?.eF2}
          commonFilter={commonFilter}
          setCommonFilter={setCommonFilter}
          dateRangeToShow={dateRangeToShow}
          setDateRangeToShow={setDateRangeToShow}
          handleResetQueryDate={handleResetQueryDate}
          setCustomStartDate={setCustomStartDate}
          setCustomEndDate={setCustomEndDate}

        />
      </div>
      {/******************************* Unit Master Modal*************************/}

      {reportAttachTo == 2 && isSliderOpen && (
        <div className={`slider-container100 ${isSliderOpen ? "open" : ""}`}>
          <div style={{ padding: "15px" }}>
            <AccountMaster1
              editData={editData}
              getdeleteId={getdeleteId}
              modelOpen={true}
              setSliderCallBack={setSliderOpen}
              fetchData={fetchData}
              data={data1}
              masterId={masterId}
            />
          </div>
        </div>
      )}
      {reportAttachTo == 4 && isSliderOpen && (
        <div className={`slider-container100 ${isSliderOpen ? "open" : ""}`}>
          <div style={{ padding: "15px" }}>
            <ItemMaster
              data={editData}
              getdeleteId={getdeleteId}
              modelOpen={true}
              setSliderCallBack={setSliderOpen}
              fetchData={fetchData} //data={data1}
              masterId={masterId}
            />
          </div>
        </div>
      )}
      {reportAttachTo == 1 && isSliderOpen && (
        <div className={`slider-container100 ${isSliderOpen ? "open" : ""}`}>
          <div style={{ padding: "15px" }}>
            <AccountGroupMaster
              editData={editData}
              getdeleteId={getdeleteId}
              modelOpen={true}
              setSliderCallBack={setSliderOpen}
              fetchData={fetchData}
              data={data1}
              masterId={masterId}
            />
          </div>
        </div>
      )}
      {reportAttachTo == 3 && isSliderOpen && (
        <div className={`slider-container100 ${isSliderOpen ? "open" : ""}`}>
          <div style={{ padding: "15px" }}>
            <ItemGroupMaster
              editData={editData}
              getdeleteId={getdeleteId}
              modelOpen={true}
              setSliderCallBack={setSliderOpen}
              fetchData={fetchData}
              data={data1}
              masterId={masterId}
            />
          </div>
        </div>
      )}
      {reportAttachTo == 8 && isSliderOpen && (
        <div className={`slider-container100 ${isSliderOpen ? "open" : ""}`}>
          <div style={{ padding: "15px" }}>
            <UnitMaster
              editData={editData}
              getdeleteId={getdeleteId}
              modelOpen={true}
              setSliderCallBack={setSliderOpen}
              fetchData={fetchData}
              data={data1}
              masterId={masterId}
            />
          </div>
        </div>
      )}

      {OpenTransportModal && (
        <TransportModal
          reportAttachTo={reportAttachTo}
          item={DetailsforTransportModal}
          OpenTModal={OpenTModal}
        />
      )}

      {/* ********************************************** Mobile View ***************************** */}
      <div className="wrapper">
        <div className="container">
          <div className=" content-row-1">
            <div className="class_control">
              <div className="balance-1">
                <div className="p-11">
                  <p className="balance-p1">
                    <i className="fa-solid fa-arrow-up icon_3"></i>Sale
                  </p>
                </div>
                <div className="p-12">
                  <p className="balance-p2">
                    <i className="fa-solid fa-indian-rupee-sign rs_sign"></i>100
                  </p>
                </div>
              </div>
              <div className="balance-1">
                <div className="p-11">
                  <p className="balance-p1">
                    {" "}
                    <i className="fa-solid fa-clipboard icon_3"></i> Total
                  </p>
                </div>
                <div className="p-12">
                  <p className="balance-p2">
                    <i className="fa-solid fa-indian-rupee-sign rs_sign"></i>200
                  </p>
                </div>
              </div>
              <div className="balance-1">
                <div className="p-11">
                  <p className="balance-p1">
                    <i className="fa-solid fa-arrow-down icon_3"></i>Return
                  </p>
                </div>
                <div className="p-12">
                  <p className="balance-p2">
                    <i className="fa-solid fa-indian-rupee-sign rs_sign"></i>100
                  </p>
                </div>
              </div>
            </div>
            <div className="class_control_2">
              <div className="parti_1">
                <div className="sub_parti_1">
                  <p className="parti-p-1">Parties</p>
                </div>
              </div>
              <div className="parti_1">
                <div className="sub_parti_1">
                  <p className="parti-p-1">Trasaction</p>
                </div>
              </div>
              <div className="parti_1">
                <div className="sub_parti_1">
                  <p className="parti-p-1">Items</p>
                </div>
              </div>
            </div>
            <div className="class_control_4">
              <div className="col_ms_1">
                <p className="p_13">Recent History</p>
                <div className="con_input_1">
                  <input
                    type="text"
                    className="input_box_2"
                    placeholder="Search..."
                  />
                </div>
              </div>

              <div className="col_sm_11">
                <div className="col_sm_21">
                  <div className="col_sm_12">
                    <div className="con_name_1">
                      <p className="con_p_3">Akash kumar</p>
                    </div>
                    <div className="con_name_1">
                      <p className="con_p_1">Sale</p>
                    </div>
                    <div className="con_name_1">
                      <p className="con_p_2">Total</p>
                    </div>
                    <div className="con_name_1">
                      <p className="con_p_4">
                        <i className="fa-solid fa-indian-rupee-sign rs_sign1"></i>
                        1000
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col_sm_13">
                  <div className="col_sm_12">
                    <div className="con_total_3">
                      <p className="con_p_3">Balance</p>
                    </div>
                    <div className="con_total_3">
                      <p className="con_price_p">
                        <i className="fa-solid fa-indian-rupee-sign rs_sign1"></i>
                        1000
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col_sm_14">
                  <div className="col_sm_12">
                    <div className="con_sale_2">
                      <p className="con_p_3">Date</p>
                    </div>
                    <div className="con_sale_2">
                      <p>#1</p>
                    </div>
                    <div className="con_name_1 con_name_7">
                      <i className="fa-solid fa-print"></i>
                      <i className="fa-solid fa-share"></i>
                      <i className="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <ListSaveButton />
            </div>
          </div>
        </div>
      </div>
      {/* ***************************** */}
      {alertBoxDelete && (
        <AlertBox
          HeadingTop="DELETE"
          Heading="Are You sure you want to delete this"
          OpenAlertBox={OpenAlertBoxDelete}
          onYesClick={DeleteTransactionConfirm}
        />
      )}
      {alertBoxConfirm && (
        <AlertBox
          HeadingTop="CONVERT"
          Heading="Are You sure you want to Convert this to Sale"
          OpenAlertBox={OpenAlertBoxConfirm}
          onYesClick={DeleteTransactionConfirm}
        />
      )}
      {/* {loading && <Loader />} */}
      <PrintModal
        heading={"Confirm !"}
        subHeading={"Do you want to print voucher !!"}
        isOpen={isPrintModalOpen}
        onClose={closeModal}
        showFormat1={true}
        showFormat2={true}
        showSendMsg={true}
        showEmail={true}
        showBarcode={true}
        Reload={Reload}
        email={email}
        PrintBill={PrintBill2}
        billSeriesWiseTemplateSetting={billSeriesWiseTemplateSetting}
      />

      {/* print bill */}
      {showBillPrint && (
        <div style={{ display: "none" }}>
          <div className="modal-back" onClick={() => setShowBillPrint(false)}>
            <div className="billPrintModal" style={{}}>
              <div style={{ padding: "5px", backgroundColor: "white" }}>
                <ReportDesignForA4
                  templateName={templateName}
                  ord1Id={transId}
                  setShowBillPrint={setShowBillPrint}
                  setLoading={setLoading}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {showBillPrintBarCode && (
        <div style={{ display: "none" }}>
          {" "}
          {/**/}
          <div className="modal-back" onClick={closeBillPrintBarCode}>
            <div className="billPrintModal" style={{}}>
              <div style={{ padding: "5px", backgroundColor: "white" }}>
                <BarCodeDesign
                  templateName={templateName}
                  ord1Id={transId}
                  setShowBillPrint={setShowBillPrintBarCode}
                  loading={loading}
                  setLoading={setLoading}
                />
              </div>
            </div>
          </div>
        </div>
      )}

       {alertBoxForSalePage && (
        <SaleInvoiceAlert
          HeadingTop="Saved"
          Heading="Saved Successfully !!"
          PrintBill={PrintBill}
          Reload={Reload}
          onYesClick={() => setAlertBoxForSalePage(false)}
          OpenAlertBox={() => setAlertBoxForSalePage(false)}
          OpenAlertBoxForSalePage={() => setAlertBoxForSalePage(false)}

        />
      )}

      <ConvertModal
        isOpen={isConvertModal}
        onClose={closeModal2}
        ModalData={ConvertDataModal}
        handleIconClick={handleIconClick}
        convertTypeList={convertTypeList}
      />

      <PayRemainingBill
        isOpen={isPaymentRem}
        onClose={closeModal3}
        masterType={reportAttachTo}
        TransId={TransId}
        Voucherinfo={Voucherinfo}
        handleIconClick={handleIconClick}
      />
      {loading && <Loader />}
      {openMessageModal && (
        <MessageSendModal
          SendSMS={SendSMS}
          SendWhatsapp={SendWhatsapp}
          SendEmail={SendEmail}
          onClose={CloseMessagebox}
          heading={"Send Message !"}
          subHeading={"Do you want to Send Message !!"}
        />
      )}

      {WorkshopModal && (
        <WorkshopModalLens
          closeWorkshopModal={closeWorkshopModal}
          WithFrameChange={WithFrameChange}
          TransId={TransId}
          SelectedItem={SelectedItem}
          companies={AllCompanies}
          setLoading={setLoading}
        />
      )}

      {isStockModalOpen && (
        <div className="modal-overlay-stockout">
          <div className="modal-stockout">
            <h2 className="modal-title-stockout">Send Stock Request</h2>
            <form onSubmit={handleStockOutSubmit}>
              {/* Company Select */}
              <div className="form-group-stockout">
                <label htmlFor="company" className="form-label-stockout">
                  Select Company
                </label>
                <select
                  id="company"
                  className="form-select-stockout"
                  value={selectedCompany}
                  onChange={(e) => setSelectedCompany(e.target.value)}
                  required
                >
                  <option value="" disabled>
                    Choose a company
                  </option>
                  {companies.length > 0 &&
                    companies.map((company, index) => (
                      <option key={index} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                </select>
              </div>

              {/* Date Field */}
              <div className="form-group-stockout">
                <label htmlFor="date" className="form-label-stockout">
                  Select Date
                </label>
                <input
                  type="date"
                  id="date"
                  className="form-input-stockout"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                />
              </div>

              {/* Submit Button */}
              <button type="submit" className="submit-btn-stockout">
                Send Request
              </button>
            </form>

            {/* Close Button */}
            <button onClick={toggleModal} className="close-btn-stockout">
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
export default MasterListReportFormat2;
